import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d048952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-wrap" }
const _hoisted_2 = { class: "block-title-wrap" }
const _hoisted_3 = { class: "block-title" }

import { computed, ref, withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'shrink-wrap',
  props: {
    title: { default: '' },
    isShrink: { type: Boolean }
  },
  emits: ['update:isShrink'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, isShrink: boolean };



const tipText = computed(() => {
  return props.isShrink ? '展开' : '收起'
})
function shrinkClickHandle() {
  emit('update:isShrink', !props.isShrink)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("div", {
        class: "block-flag-wrap",
        onClick: shrinkClickHandle
      }, [
        _createElementVNode("span", null, _toDisplayString(_unref(tipText)), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["icon-down-svg arrow", { down: !props.isShrink }])
        }, null, 2)
      ])
    ]),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})